export default __webpack_public_path__ + "static/media/ibm.f494bad7.png";